import { useCallback } from "react";
import { useCurrentAccountId } from "@zapier/identity";
import emitUserInteractionEvent, {
  UserInteractionName,
} from "./emitUserInteractionEvent";

export type ShareEventInteractionOption =
  | "share_canvas"
  | "share_folder"
  | "share_interface"
  | "share_table"
  | "share_chatbot";

interface EmitShareInteractionEvent {
  optionSelected: ShareEventInteractionOption;
  assetId?: string;
  subjectId?: string;
}

export function useEmitShareInteractionEvent() {
  const accountId = useCurrentAccountId();

  const emit = useCallback(
    ({ optionSelected, assetId, subjectId }: EmitShareInteractionEvent) => {
      emitUserInteractionEvent({
        accountId,
        interactionName: UserInteractionName.ShareModal,
        optionSelected,
        customTrackingFields: {
          subject_id: subjectId,
          asset_id: assetId,
        },
      });
    },
    [accountId],
  );

  return {
    emit,
  };
}
